import React from "react";
import PT from "prop-types";
import FormMessage from "_c/form/Message";
import GoMailBtn from "../GoMailBtn";
import * as S from "./styled";

const FinalStepEmail = (props) => {
  return (
    <S.Wrap>
      <FormMessage
        message={props.t("login:reg_success", {
          email: props.email,
        })}
      />
      <GoMailBtn onClose={props.onClose} t={props.t} email={props.email} />
    </S.Wrap>
  );
};
FinalStepEmail.propTypes = {
  email: PT.string.isRequired,
  onClose: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default FinalStepEmail;
